import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=b962abea&scoped=true&"
import script from "./TransactionTable.vue?vue&type=script&lang=ts&"
export * from "./TransactionTable.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=b962abea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b962abea",
  null
  
)

export default component.exports